/**
 * Safely formats a date value that can be a string, array, or undefined
 * @param dateValue - The date value (string, array of numbers, or undefined)
 * @param format - The format type: 'date' for date only, 'datetime' for date and time
 * @returns Formatted date string or 'N/A' if invalid
 */
export function formatDate(
  dateValue: string | number[] | undefined | null,
  format: 'date' | 'datetime' = 'date'
): string {
  if (!dateValue) {
    return 'N/A';
  }

  try {
    let date: Date;

    if (Array.isArray(dateValue)) {
      // Handle array format: [year, month, day, hour, minute, second]
      date = new Date(
        dateValue[0],
        (dateValue[1] || 1) - 1,
        dateValue[2] || 1,
        dateValue[3] || 0,
        dateValue[4] || 0,
        dateValue[5] || 0
      );
    } else if (typeof dateValue === 'string') {
      date = new Date(dateValue);
    } else {
      return 'N/A';
    }

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return 'N/A';
    }

    // Format based on requested format
    return format === 'datetime' ? date.toLocaleString() : date.toLocaleDateString();
  } catch {
    return 'N/A';
  }
}
